import { useQuery } from '@apollo/client';
import { LIST_UNLOCKED_AVAILABLE_DELIVERY_DAYS, GET_USER_SWAP_BILLING_SUMMARY } from 'core/api/apollo/queries';

export const useCheckoutData = () => {
  const { data: { listUnlockedAvailableDeliveryDays = [] } = {} } = useQuery(
    LIST_UNLOCKED_AVAILABLE_DELIVERY_DAYS
  );

  const deliveryDays = listUnlockedAvailableDeliveryDays.filter(
    (day) => !day.locked && day.menuPublished
  );
  const deliveryDayIds = deliveryDays.map((day) => day.id);

  const variables = { deliveryDayIds: deliveryDayIds.toString() };

  const { loading, error, data: { getUserSwapBillingSummary = [] } = {}, refetch: refetchBillingSummary } = useQuery(GET_USER_SWAP_BILLING_SUMMARY, {
    variables,
    skip: deliveryDayIds.length === 0,
    fetchPolicy: 'network-only',
  });

  return {
    loading,
    error,
    deliveryDays,
    userSwapBillingSummary: getUserSwapBillingSummary,
    refetchBillingSummary,
  };
};
